<template>
	<div>
		<div class="text-end mb-3" v-if="isPetugasPresensi">
			<el-button type="info" icon="Plus" plain round @click="dialogCreateVisible = true">Tambah izin</el-button>
		</div>
		<el-divider content-position="left" border-style="dotted">Filter</el-divider>
		<el-form label-width="auto" label-position="top">
			<el-row :gutter="10" align="middle">
				<el-col :xs="24" :sm="12" :md="10" :xl="7">
					<el-form-item label="Non-GTK" prop="user_presensi_id">
						<el-select v-model="izinFilter.user_presensi_id" filterable placeholder="Pilih Non-GTK" clearable>
							<el-option v-for="u in listUser" :key="u.user_presensi_id" :label="u.nama" :value="u.user_presensi_id" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="16" :md="14" :xl="9">
					<el-form-item label="Tanggal" prop="tanggal">
						<el-date-picker
							v-model="izinFilter.tanggal"
							type="daterange"
							range-separator="s/d"
							format="DD MMMM YYYY"
							value-format="YYYY-MM-DD"
							start-placeholder="Tanggal Awal"
							end-placeholder="Tanggal Akhir" />
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="8" :md="6" :xl="4">
					<el-form-item label="Izin Masuk" prop="izin_masuk">
						<el-select v-model="izinFilter.izin_masuk" placeholder="Jenis izin" clearable>
							<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="8" :md="6" :xl="4">
					<el-form-item label="Izin Pulang" prop="izin_pulang">
						<el-select v-model="izinFilter.izin_pulang" placeholder="Jenis izin" clearable>
							<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="8" :md="6" :xl="4">
					<el-form-item label="Izin Penuh" prop="izin_penuh">
						<el-select v-model="izinFilter.izin_penuh" placeholder="Jenis izin" clearable>
							<el-option v-for="i in jenisPenuh" :key="i" :label="i" :value="i" />
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-divider border-style="dotted" />

		<el-table :data="izinPresensi" row-key="izin_presensi_id" table-layout="auto" v-loading="loading">
			<template #empty>
				<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
			</template>
			<el-table-column type="index" label="No." :index="indexMethod" />
			<el-table-column label="Nama" prop="nama" />
			<el-table-column label="ID Presensi" prop="user_presensi_id">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Hari/Tanggal" prop="tanggal_formatted">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.tanggal_formatted">{{ row.tanggal_formatted }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Izin Masuk" prop="izin_masuk">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.izin_masuk">{{ row.izin_masuk || "-" }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Izin Pulang" prop="izin_pulang">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.izin_pulang">{{ row.izin_pulang || "-" }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Izin Penuh" prop="izin_penuh">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.izin_penuh">{{ row.izin_penuh || "-" }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Keterangan" prop="keterangan">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<div class="hstack gap-1 justify-content-between" :key="row.keterangan">
							{{ row.keterangan || "-" }}
							<el-tooltip>
								<template #content>
									Dibuat: <em>{{ row.created_at }}</em>
									<br />
									Diperbarui: <em>{{ row.updated_at || "-" }}</em>
								</template>
								<el-icon><i class="bi bi-info-circle"></i></el-icon>
							</el-tooltip>
						</div>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Bukti Izin" prop="bukti_izin">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<el-image
							v-if="row.bukti_izin"
							style="width: 80px; height: 80px"
							:src="row.previewBuktiIzin"
							:preview-src-list="[row.previewBuktiIzin]"
							:preview-teleported="true"
							show-progress
							fit="scale-down"
							lazy
							class="shadow bg-white border">
							<template #error>
								<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
									<el-icon class="fs-2"><Picture /></el-icon>
									<em class="small">Gagal dimuat</em>
								</el-space>
							</template>
						</el-image>
						<span v-else>-</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Tindakan" v-if="isPetugasPresensi">
				<template #default="{ row }">
					<el-space :spacer="spacer" :size="2">
						<el-tooltip content="Edit data">
							<el-button type="primary" size="small" icon="Edit" plain round @click="editData(row)" />
						</el-tooltip>
						<el-tooltip content="Hapus data">
							<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
						</el-tooltip>
					</el-space>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			class="flex-wrap justify-content-center mt-3"
			v-model:current-page="currentPage"
			v-model:page-size="pageSize"
			:page-sizes="[5, 10, 25, 50, 100]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalData"
			@change="getIzinPresensi" />

		<el-form
			:model="formCreate"
			:rules="rulesCreate"
			ref="formCreate"
			@submit.prevent="insertIzinPresensi"
			label-width="auto"
			:disabled="inserting"
			:validate-on-rule-change="false">
			<el-dialog v-model="dialogCreateVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Tambah Izin Presensi" align-center :width="modalWidth">
				<el-form-item prop="user_presensi_id" label="Non-GTK">
					<el-select v-model="formCreate.user_presensi_id" filterable placeholder="Pilih Non-GTK">
						<el-option v-for="u in listUser" :key="u.user_presensi_id" :label="u.nama" :value="u.user_presensi_id" />
					</el-select>
				</el-form-item>
				<el-form-item prop="tanggal" label="Tanggal">
					<el-date-picker v-model="formCreate.tanggal" format="DD MMMM YYYY" value-format="YYYY-MM-DD" placeholder="Tanggal" />
				</el-form-item>
				<el-form-item prop="izin_masuk" label="Izin Masuk">
					<el-select v-model="formCreate.izin_masuk" placeholder="Jenis izin" clearable>
						<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
					</el-select>
				</el-form-item>
				<el-form-item prop="izin_pulang" label="Izin Pulang">
					<el-select v-model="formCreate.izin_pulang" placeholder="Jenis izin" clearable>
						<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
					</el-select>
				</el-form-item>
				<el-form-item prop="izin_penuh" label="Izin Penuh">
					<el-select v-model="formCreate.izin_penuh" placeholder="Jenis izin" clearable>
						<el-option v-for="i in jenisPenuh" :key="i" :label="i" :value="i" />
					</el-select>
				</el-form-item>
				<el-form-item prop="keterangan" label="Keterangan">
					<el-input v-model="formCreate.keterangan" autosize type="textarea" placeholder="Keterangan izin" />
				</el-form-item>
				<el-form-item prop="bukti_izin" label="Bukti Izin">
					<el-space alignment="start" direction="vertical">
						<el-space wrap>
							<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleBuktiIzinCreate" accept="image/*">
								<template #trigger>
									<transition name="fade" mode="out-in">
										<el-button plain icon="Camera" type="info">Pilih gambar bukti izin</el-button>
									</transition>
								</template>
							</el-upload>
							<transition name="fade" mode="out-in">
								<el-button v-if="formCreate.bukti_izin" icon="Delete" type="danger" plain @click="handleBuktiIzinCreate(null)">Hapus</el-button>
							</transition>
						</el-space>
						<el-space wrap>
							<transition name="slide-up" mode="out-in">
								<el-image
									v-if="formCreate.bukti_izin"
									:key="formCreate.bukti_izin"
									style="width: 150px; height: 150px"
									:src="previewBuktiIzinCreate"
									:preview-src-list="[previewBuktiIzinCreate]"
									fit="scale-down"
									lazy
									class="shadow bg-white border">
									<template #error>
										<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
											<el-icon class="fs-2"><Picture /></el-icon>
											<em class="small">Gagal dimuat</em>
										</el-space>
									</template>
								</el-image>
							</transition>
						</el-space>
					</el-space>
				</el-form-item>
				<template #footer>
					<el-button type="info" plain @click="dialogCreateVisible = false">Batal</el-button>
					<el-button type="success" native-type="submit" :loading="inserting">Simpan</el-button>
				</template>
			</el-dialog>
		</el-form>

		<el-form :model="formEdit" :rules="rulesEdit" ref="formEdit" @submit.prevent="updateIzinPresensi" label-width="auto" :disabled="updating" :validate-on-rule-change="true">
			<el-dialog v-model="dialogEditVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Edit Izin Presensi" align-center :width="modalWidth">
				<el-form-item prop="user_presensi_id" label="Non-GTK">
					<el-select v-model="formEdit.user_presensi_id" filterable :placeholder="rowEditing?.nama">
						<el-option v-for="u in listUser" :key="u.user_presensi_id" :label="u.nama" :value="u.user_presensi_id" />
					</el-select>
				</el-form-item>
				<el-form-item prop="tanggal" label="Tanggal">
					<el-date-picker v-model="formEdit.tanggal" format="DD MMMM YYYY" value-format="YYYY-MM-DD" :placeholder="rowEditing?.tanggal_formatted" />
				</el-form-item>
				<el-form-item prop="izin_masuk" label="Izin Masuk">
					<el-select v-model="formEdit.izin_masuk" :placeholder="rowEditing?.izin_masuk || 'Jenis izin'" clearable :class="formEdit.del_izin_masuk ? 'deleted-value' : ''">
						<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
					</el-select>
					<el-form-item prop="del_izin_masuk" class="mb-0">
						<el-checkbox v-model="formEdit.del_izin_masuk" label="Kosongkan" size="small" :disabled="!rowEditing?.izin_masuk" />
					</el-form-item>
				</el-form-item>
				<el-form-item prop="izin_pulang" label="Izin Pulang">
					<el-select v-model="formEdit.izin_pulang" :placeholder="rowEditing?.izin_pulang || 'Jenis izin'" clearable :class="formEdit.del_izin_pulang ? 'deleted-value' : ''">
						<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
					</el-select>
					<el-form-item prop="del_izin_pulang" class="mb-0">
						<el-checkbox v-model="formEdit.del_izin_pulang" label="Kosongkan" size="small" :disabled="!rowEditing?.izin_pulang" />
					</el-form-item>
				</el-form-item>
				<el-form-item prop="izin_penuh" label="Izin Penuh">
					<el-select v-model="formEdit.izin_penuh" :placeholder="rowEditing?.izin_penuh || 'Jenis izin'" clearable :class="formEdit.del_izin_penuh ? 'deleted-value' : ''">
						<el-option v-for="i in jenisPenuh" :key="i" :label="i" :value="i" />
					</el-select>
					<el-form-item prop="del_izin_penuh" class="mb-0">
						<el-checkbox v-model="formEdit.del_izin_penuh" label="Kosongkan" size="small" :disabled="!rowEditing?.izin_penuh" />
					</el-form-item>
				</el-form-item>
				<el-form-item prop="keterangan" label="Keterangan">
					<el-input
						v-model="formEdit.keterangan"
						autosize
						type="textarea"
						:placeholder="rowEditing?.keterangan || 'Keterangan izin'"
						:class="formEdit.del_keterangan ? 'deleted-value' : ''" />
					<el-form-item prop="del_keterangan" class="mb-0">
						<el-checkbox v-model="formEdit.del_keterangan" label="Kosongkan" size="small" :disabled="!rowEditing?.keterangan" />
					</el-form-item>
				</el-form-item>
				<el-form-item prop="bukti_izin" label="Bukti Izin">
					<el-space alignment="start" direction="vertical">
						<el-space wrap>
							<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleBuktiIzinEdit" accept="image/*">
								<template #trigger>
									<transition name="fade" mode="out-in">
										<el-button v-if="rowEditing?.bukti_izin || formEdit.bukti_izin" icon="Refresh" type="primary" plain>Ubah gambar bukti izin</el-button>
										<el-button v-else plain icon="Camera" type="info">Pilih gambar bukti izin</el-button>
									</transition>
								</template>
							</el-upload>
							<transition name="fade" mode="out-in">
								<el-button v-if="formEdit.bukti_izin" icon="Delete" type="danger" plain @click="handleBuktiIzinEdit(null)">Hapus</el-button>
							</transition>
						</el-space>
						<el-space wrap :spacer="formEdit.bukti_izin ? switchSpacer : ''">
							<el-image
								v-if="rowEditing?.bukti_izin"
								:key="rowEditing?.bukti_izin"
								style="width: 150px; height: 150px"
								:src="rowEditing?.previewBuktiIzin"
								:preview-src-list="[rowEditing?.previewBuktiIzin]"
								fit="scale-down"
								lazy
								class="shadow bg-white border">
								<template #error>
									<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
										<el-icon class="fs-2"><Picture /></el-icon>
										<em class="small">Gagal dimuat</em>
									</el-space>
								</template>
							</el-image>
							<transition name="slide-up" mode="out-in">
								<el-image
									v-if="formEdit.bukti_izin"
									:key="formEdit.bukti_izin"
									style="width: 150px; height: 150px"
									:src="previewBuktiIzinEdit"
									:preview-src-list="[previewBuktiIzinEdit]"
									fit="scale-down"
									lazy
									class="shadow bg-white border">
									<template #error>
										<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
											<el-icon class="fs-2"><Picture /></el-icon>
											<em class="small">Gagal dimuat</em>
										</el-space>
									</template>
								</el-image>
							</transition>
						</el-space>
						<el-form-item prop="del_bukti_izin" class="mb-0">
							<el-checkbox v-model="formEdit.del_bukti_izin" label="Kosongkan" size="small" :disabled="!rowEditing?.bukti_izin" />
						</el-form-item>
					</el-space>
				</el-form-item>
				<template #footer>
					<el-button type="info" plain @click="cancelEdit">Batal</el-button>
					<el-button type="primary" native-type="submit" :loading="updating">Perbarui</el-button>
				</template>
			</el-dialog>
		</el-form>
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";

export default {
	name: "IzinNonGtk",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			switchSpacer: h("i", { class: "bi bi-arrow-left-right" }),
			izinPresensi: [],
			listUser: [],
			dialogCreateVisible: false,
			dialogEditVisible: false,
			formCreate: {
				user_presensi_id: null,
				tanggal: null,
				izin_masuk: null,
				izin_pulang: null,
				izin_penuh: null,
				keterangan: null,
				bukti_izin: null,
			},
			previewBuktiIzinCreate: null,
			previewBuktiIzinEdit: null,
			rowEditing: null,
			formEdit: {
				user_presensi_id: null,
				tanggal: null,
				izin_masuk: null,
				del_izin_masuk: false,
				izin_pulang: null,
				del_izin_pulang: false,
				izin_penuh: null,
				del_izin_penuh: false,
				keterangan: null,
				del_keterangan: false,
				bukti_izin: null,
				del_bukti_izin: false,
			},
			izinFilter: {
				user_presensi_id: null,
				tanggal: null,
				izin_masuk: null,
				izin_pulang: null,
				izin_penuh: null,
			},
			rulesCreate: {
				user_presensi_id: [{ required: true, message: "Silakan pilih pengguna", trigger: "change" }],
				tanggal: [{ required: true, message: "Silakan pilih tanggal izin", trigger: "change" }],
				izin_masuk: [{ required: true, message: "Silakan pilih jenis izin masuk", trigger: "change" }],
				izin_pulang: [{ required: true, message: "Silakan pilih jenis izin pulang", trigger: "change" }],
				izin_penuh: [{ required: true, message: "Silakan pilih jenis izin penuh", trigger: "change" }],
			},
			rulesEdit: {
				izin_masuk: [{ required: false, message: "", trigger: "change" }],
				izin_pulang: [{ required: false, message: "", trigger: "change" }],
				izin_penuh: [{ required: false, message: "", trigger: "change" }],
			},
			debounceFetch: null,
			inserting: false,
			loading: true,
			updating: false,
			deleting: false,
			syncing: false,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		updateEditing: Function,
		isPetugasPresensi: Boolean,
		jenisMasukPulang: Array,
		jenisPenuh: Array,
		modalWidth: String,
	},
	computed: {
		formEditChanged() {
			if (this.rowEditing) {
				const payload = Object.fromEntries(
					Object.entries(this.formEdit).filter(([key, value]) => {
						const isChanged = value !== this.rowEditing[key];
						const isNotEmpty = value !== "" && value !== null && value !== undefined;
						const isTrueValue = !(typeof value === "boolean" && value === false);

						return isChanged && isNotEmpty && isTrueValue;
					}),
				);

				return Object.keys(payload).length > 0;
			}

			return false;
		},
		izinFilterClone() {
			return JSON.parse(JSON.stringify(this.izinFilter));
		},
		formCreateClone() {
			return JSON.parse(JSON.stringify(this.formCreate));
		},
		formEditClone() {
			return JSON.parse(JSON.stringify(this.formEdit));
		},
	},
	watch: {
		izinFilterClone: {
			handler(newVal, oldVal) {
				if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;

				clearTimeout(this.debounceFetch);

				this.debounceFetch = setTimeout(() => {
					const izinMasukChanged = newVal.izin_masuk !== oldVal.izin_masuk;
					const izinPulangChanged = newVal.izin_pulang !== oldVal.izin_pulang;
					const izinPenuhChanged = newVal.izin_penuh !== oldVal.izin_penuh;

					if ((izinMasukChanged && newVal.izin_masuk !== null) || (izinPulangChanged && newVal.izin_pulang !== null)) {
						if (this.izinFilter.izin_penuh !== null) {
							this.izinFilter.izin_penuh = null;

							return;
						}
					}

					if (izinPenuhChanged && newVal.izin_penuh !== null) {
						if (this.izinFilter.izin_masuk !== null || this.izinFilter.izin_pulang !== null) {
							this.izinFilter.izin_masuk = null;
							this.izinFilter.izin_pulang = null;

							return;
						}
					}

					if (this.currentPage === 1) this.getIzinPresensi();
					else this.currentPage = 1;
				}, 0);
			},
			deep: true,
		},
		formCreateClone: {
			async handler(newVal, oldVal) {
				const izinMasukChanged = newVal.izin_masuk !== oldVal.izin_masuk;
				const izinPulangChanged = newVal.izin_pulang !== oldVal.izin_pulang;
				const izinPenuhChanged = newVal.izin_penuh !== oldVal.izin_penuh;

				if (izinMasukChanged || izinPulangChanged || izinPenuhChanged) {
					this.$refs.formCreate.validate();
				}

				if ((izinMasukChanged && newVal.izin_masuk !== null) || (izinPulangChanged && newVal.izin_pulang !== null)) {
					this.formCreate.izin_penuh = null;
				}

				if (izinPenuhChanged && newVal.izin_penuh !== null) {
					this.formCreate.izin_masuk = null;
					this.formCreate.izin_pulang = null;
				}

				const hasAtLeastOneIzin = newVal.izin_masuk !== null || newVal.izin_pulang !== null || newVal.izin_penuh !== null;

				if (!hasAtLeastOneIzin) {
					this.rulesCreate = {
						...this.rulesCreate,
						izin_masuk: [{ required: true, message: "Silakan pilih jenis izin masuk", trigger: "change" }],
						izin_pulang: [{ required: true, message: "Silakan pilih jenis izin pulang", trigger: "change" }],
						izin_penuh: [{ required: true, message: "Silakan pilih jenis izin penuh", trigger: "change" }],
					};
				} else {
					this.rulesCreate = {
						...this.rulesCreate,
						izin_masuk: [{ required: false, message: "", trigger: "change" }],
						izin_pulang: [{ required: false, message: "", trigger: "change" }],
						izin_penuh: [{ required: false, message: "", trigger: "change" }],
					};
				}
			},
			deep: true,
		},
		formEditClone: {
			async handler(newVal, oldVal) {
				const izinMasukChanged = newVal.izin_masuk !== oldVal.izin_masuk;
				const izinPulangChanged = newVal.izin_pulang !== oldVal.izin_pulang;
				const izinPenuhChanged = newVal.izin_penuh !== oldVal.izin_penuh;
				const keteranganChanged = newVal.keterangan !== oldVal.keterangan;
				const buktiIzinChanged = newVal.bukti_izin !== oldVal.bukti_izin;
				const delIzinMasukChanged = newVal.del_izin_masuk !== oldVal.del_izin_masuk;
				const delIzinPulangChanged = newVal.del_izin_pulang !== oldVal.del_izin_pulang;
				const delIzinPenuhChanged = newVal.del_izin_penuh !== oldVal.del_izin_penuh;
				const delKeteranganChanged = newVal.del_keterangan !== oldVal.del_keterangan;
				const delBuktiIzinChanged = newVal.del_bukti_izin !== oldVal.del_bukti_izin;

				if (izinMasukChanged && newVal.izin_masuk !== null) {
					this.formEdit.del_izin_masuk = false;

					if (this.rowEditing?.izin_penuh !== null) this.formEdit.del_izin_penuh = true;

					this.formEdit.izin_penuh = null;
				}

				if (izinPulangChanged && newVal.izin_pulang !== null) {
					this.formEdit.del_izin_pulang = false;

					if (this.rowEditing?.izin_penuh !== null) this.formEdit.del_izin_penuh = true;

					this.formEdit.izin_penuh = null;
				}

				if (izinPenuhChanged && newVal.izin_penuh !== null) {
					this.formEdit.del_izin_penuh = false;

					if (this.rowEditing?.izin_masuk) this.formEdit.del_izin_masuk = true;

					if (this.rowEditing?.izin_pulang !== null) this.formEdit.del_izin_pulang = true;
				}

				if (keteranganChanged && newVal.keterangan !== null) {
					this.formEdit.del_keterangan = false;
				}

				if (buktiIzinChanged && newVal.bukti_izin !== null) {
					this.formEdit.del_bukti_izin = false;
				}

				if (delIzinMasukChanged && newVal.del_izin_masuk) {
					this.formEdit.izin_masuk = null;
				}

				if (delIzinPulangChanged && newVal.del_izin_pulang) {
					this.formEdit.izin_pulang = null;
				}

				if (delIzinPenuhChanged && newVal.del_izin_penuh) {
					this.formEdit.izin_penuh = null;
				}

				if (delKeteranganChanged && newVal.del_keterangan) {
					this.formEdit.keterangan = null;
				}

				if (delBuktiIzinChanged && newVal.del_bukti_izin) {
					this.formEdit.bukti_izin = null;
				}

				const finalIzinMasuk = newVal.del_izin_masuk ? null : newVal.izin_masuk || this.rowEditing?.izin_masuk;
				const finalIzinPulang = newVal.del_izin_pulang ? null : newVal.izin_pulang || this.rowEditing?.izin_pulang;
				const finalIzinPenuh = newVal.del_izin_penuh ? null : newVal.izin_penuh || this.rowEditing?.izin_penuh;

				const hasAtLeastOneIzin = finalIzinMasuk !== null || finalIzinPulang !== null || finalIzinPenuh !== null;

				if (!hasAtLeastOneIzin) {
					this.rulesEdit = {
						...this.rulesEdit,
						izin_masuk: [{ required: true, message: "Silakan pilih jenis izin masuk", trigger: "change" }],
						izin_pulang: [{ required: true, message: "Silakan pilih jenis izin pulang", trigger: "change" }],
						izin_penuh: [{ required: true, message: "Silakan pilih jenis izin penuh", trigger: "change" }],
					};
				} else {
					this.rulesEdit = {
						...this.rulesEdit,
						izin_masuk: [{ required: false, message: "", trigger: "change" }],
						izin_pulang: [{ required: false, message: "", trigger: "change" }],
						izin_penuh: [{ required: false, message: "", trigger: "change" }],
					};
				}
			},
			deep: true,
		},
		formEditChanged(val) {
			this.updateEditing(val);
		},
		dialogCreateVisible() {
			this.$refs.formCreate.resetFields();
			this.previewBuktiIzinCreate = null;
		},
		dialogEditVisible(val) {
			if (!val) this.cancelEdit();
		},
	},
	mounted() {
		this.$ws.main.on("izin:inserted", this.insertedIzin);
		this.$ws.main.on("izin:updated", this.updatedIzin);
		this.$ws.main.on("izin:deleted", this.deletedIzin);
		this.$ws.main.on("user:inserted", this.insertedUser);
		this.$ws.main.on("user:updated", this.updatedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.getIzinPresensi();
		this.getListUserPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("izin:inserted");
		this.$ws.main.off("izin:updated");
		this.$ws.main.off("izin:deleted");
		this.$ws.main.off("user:inserted");
		this.$ws.main.off("user:updated");
		this.$ws.main.off("user:deleted");
	},
	beforeRouteLeave(to, from, next) {
		if (this.formEditChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		handleBuktiIzinCreate(file) {
			if (file) {
				this.formCreate.bukti_izin = file.raw;
				this.previewBuktiIzinCreate = URL.createObjectURL(file.raw);
			} else {
				this.formCreate.bukti_izin = null;
				this.previewBuktiIzinCreate = null;
			}
		},
		handleBuktiIzinEdit(file) {
			if (file) {
				this.formEdit.bukti_izin = file.raw;
				this.previewBuktiIzinEdit = URL.createObjectURL(file.raw);
			} else {
				this.formEdit.bukti_izin = null;
				this.previewBuktiIzinEdit = null;
			}
		},
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		isDateInRange(rentangTanggal = [], tanggal) {
			const awal = new Date(rentangTanggal[0] + "T00:00:00+07:00");
			const akhir = new Date(rentangTanggal[1] + "T23:59:59.999+07:00");

			const tanggalData = new Date(tanggal);

			return tanggalData >= awal && tanggalData <= akhir;
		},
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		insertedIzin(data) {
			const newData = data;

			if (newData.type !== "non_gtk") return;

			const userFiltered = this.izinFilter.user_presensi_id !== null && this.izinFilter.user_presensi_id !== "";
			const dateRangeFiltered = Array.isArray(this.izinFilter.tanggal);
			const izinMasukFiltered = this.izinFilter.izin_masuk !== null && this.izinFilter.izin_masuk !== "";
			const izinPulangFiltered = this.izinFilter.izin_pulang !== null && this.izinFilter.izin_pulang !== "";
			const izinPenuhFiltered = this.izinFilter.izin_penuh !== null && this.izinFilter.izin_penuh !== "";

			const newUserMatched = !userFiltered || newData.user_presensi_id === this.izinFilter.user_presensi_id;
			const newDateMatched = !dateRangeFiltered || this.isDateInRange(this.izinFilter.tanggal, newData.tanggal);
			const newIzinMasukMatched = !izinMasukFiltered || newData.izin_masuk === this.izinFilter.izin_masuk;
			const newIzinPulangMatched = !izinPulangFiltered || newData.izin_pulang === this.izinFilter.izin_pulang;
			const newIzinPenuhMatched = !izinPenuhFiltered || newData.izin_penuh === this.izinFilter.izin_penuh;

			if (userFiltered && !newUserMatched) {
				return;
			}

			if (dateRangeFiltered && !newDateMatched) {
				return;
			}

			if (izinMasukFiltered && !newIzinMasukMatched) {
				return;
			}

			if (izinPulangFiltered && !newIzinPulangMatched) {
				return;
			}

			if (izinPenuhFiltered && !newIzinPenuhMatched) {
				return;
			}

			const newMatched = newUserMatched && newDateMatched && newIzinMasukMatched && newIzinPulangMatched && newIzinPenuhMatched;

			if (!newMatched) {
				return;
			}

			const temp = [...this.izinPresensi];

			const formttedNewData = {
				...newData,
				tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
				created_at: new Date(newData.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
				previewBuktiIzin: newData.bukti_izin ? `${process.env.VUE_APP_API}/izin/bukti-izin/${newData.izin_presensi_id}?ts=${Date.now()}` : null,
			};

			temp.push(formttedNewData);

			temp.sort((a, b) => {
				const tglA = new Date(a.tanggal);
				const tglB = new Date(b.tanggal);

				return tglA - tglB || a.nama.localeCompare(b.nama);
			});

			const newDataIndex = temp.findIndex((t) => t.izin_presensi_id === newData.izin_presensi_id);

			if (newDataIndex === this.pageSize) {
				this.totalData++;
				return;
			}

			if (newDataIndex === 0 && this.currentPage > 1) {
				this.getIzinPresensi();
				return;
			}

			this.izinPresensi.splice(newDataIndex, 0, formttedNewData);

			if (this.izinPresensi.length > this.pageSize) this.izinPresensi.pop();

			this.totalData++;
		},
		updatedIzin(data) {
			const oldData = data.old_izin_presensi;
			const newData = data.new_izin_presensi;

			if (oldData.type !== "non_gtk" && newData.type !== "non_gtk") return;

			const totalPages = Math.ceil(this.totalData / this.pageSize);

			const userFiltered = this.izinFilter.user_presensi_id !== null && this.izinFilter.user_presensi_id !== "";
			const dateRangeFiltered = Array.isArray(this.izinFilter.tanggal);
			const izinMasukFiltered = this.izinFilter.izin_masuk !== null && this.izinFilter.izin_masuk !== "";
			const izinPulangFiltered = this.izinFilter.izin_pulang !== null && this.izinFilter.izin_pulang !== "";
			const izinPenuhFiltered = this.izinFilter.izin_penuh !== null && this.izinFilter.izin_penuh !== "";

			const oldUserMatched = !userFiltered || oldData.user_presensi_id === this.izinFilter.user_presensi_id;
			const oldDateMatched = !dateRangeFiltered || this.isDateInRange(this.izinFilter.tanggal, oldData.tanggal);
			const oldIzinMasukMatched = !izinMasukFiltered || oldData.izin_masuk === this.izinFilter.izin_masuk;
			const oldIzinPulangMatched = !izinPulangFiltered || oldData.izin_pulang === this.izinFilter.izin_pulang;
			const oldIzinPenuhMatched = !izinPenuhFiltered || oldData.izin_penuh === this.izinFilter.izin_penuh;

			const newUserMatched = !userFiltered || newData.user_presensi_id === this.izinFilter.user_presensi_id;
			const newDateMatched = !dateRangeFiltered || this.isDateInRange(this.izinFilter.tanggal, newData.tanggal);
			const newIzinMasukMatched = !izinMasukFiltered || newData.izin_masuk === this.izinFilter.izin_masuk;
			const newIzinPulangMatched = !izinPulangFiltered || newData.izin_pulang === this.izinFilter.izin_pulang;
			const newIzinPenuhMatched = !izinPenuhFiltered || newData.izin_penuh === this.izinFilter.izin_penuh;

			if (userFiltered && !oldUserMatched && !newUserMatched) {
				return;
			}

			if (dateRangeFiltered && !oldDateMatched && !newDateMatched) {
				return;
			}

			if (izinMasukFiltered && !oldIzinMasukMatched && !newIzinMasukMatched) {
				return;
			}

			if (izinPulangFiltered && !oldIzinPulangMatched && !newIzinPulangMatched) {
				return;
			}

			if (izinPenuhFiltered && !oldIzinPenuhMatched && !newIzinPenuhMatched) {
				return;
			}

			const oldMatched = oldUserMatched && oldDateMatched && oldIzinMasukMatched && oldIzinPulangMatched && oldIzinPenuhMatched;

			const newMatched = newUserMatched && newDateMatched && newIzinMasukMatched && newIzinPulangMatched && newIzinPenuhMatched;

			if (!oldMatched && !newMatched) {
				return;
			}

			if (!oldMatched && newMatched) {
				const temp = [...this.izinPresensi];

				const formttedNewData = {
					...newData,
					tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
					created_at: new Date(newData.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					updated_at: new Date(newData.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					previewBuktiIzin: newData.bukti_izin ? `${process.env.VUE_APP_API}/izin/bukti-izin/${newData.izin_presensi_id}?ts=${Date.now()}` : null,
				};

				temp.push(formttedNewData);

				temp.sort((a, b) => {
					const tglA = new Date(a.tanggal);
					const tglB = new Date(b.tanggal);

					return tglA - tglB || a.nama.localeCompare(b.nama);
				});

				const newDataIndex = temp.findIndex((t) => t.izin_presensi_id === newData.izin_presensi_id);

				if (newDataIndex === this.pageSize) {
					this.totalData++;
					return;
				}

				if (newDataIndex === 0 && this.currentPage > 1) {
					this.getIzinPresensi();
					return;
				}

				this.izinPresensi.splice(newDataIndex, 0, formttedNewData);

				if (this.izinPresensi.length > this.pageSize) this.izinPresensi.pop();

				this.totalData++;

				return;
			}

			if (oldMatched && !newMatched) {
				const existIndex = this.izinPresensi.findIndex((ip) => ip.izin_presensi_id === oldData.izin_presensi_id);

				if (existIndex !== -1) {
					if (this.rowEditing && this.rowEditing.izin_presensi_id === oldData.izin_presensi_id) this.cancelEdit();

					if (this.currentPage === totalPages) {
						this.izinPresensi.splice(existIndex, 1);
						this.totalData--;
						return;
					}

					this.getIzinPresensi();
					return;
				}

				const temp = [...this.izinPresensi];

				temp.push(oldData);
				temp.sort((a, b) => {
					const tglA = new Date(a.tanggal);
					const tglB = new Date(b.tanggal);

					return tglA - tglB || a.nama.localeCompare(b.nama);
				});

				const oldDataIndex = temp.findIndex((t) => t.izin_presensi_id === oldData.izin_presensi_id);
				if (oldDataIndex === this.pageSize) {
					this.totalData--;
					return;
				}

				if (oldDataIndex === 0 && this.currentPage === totalPages) {
					this.izinPresensi.shift();
					this.totalData--;
					return;
				}

				this.getIzinPresensi();
				return;
			}

			if (oldMatched && newMatched) {
				const existIndex = this.izinPresensi.findIndex((ip) => ip.izin_presensi_id === oldData.izin_presensi_id);

				if (existIndex !== -1) {
					if (this.rowEditing && this.rowEditing.izin_presensi_id === oldData.izin_presensi_id) this.cancelEdit();

					const tempExists = [...this.izinPresensi];

					tempExists[existIndex] = {
						...newData,
						tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
						created_at: new Date(newData.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
						updated_at: new Date(newData.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
						previewBuktiIzin: newData.bukti_izin ? `${process.env.VUE_APP_API}/izin/bukti-izin/${newData.izin_presensi_id}?ts=${Date.now()}` : null,
					};

					tempExists.sort((a, b) => {
						const tglA = new Date(a.tanggal);
						const tglB = new Date(b.tanggal);

						return tglA - tglB || a.nama.localeCompare(b.nama);
					});

					if (this.izinPresensi.length < this.pageSize) {
						this.izinPresensi = tempExists;
						return;
					}

					const checkIndex = tempExists.findIndex((ip) => ip.izin_presensi_id === oldData.izin_presensi_id);

					if ((checkIndex === 0 && this.currentPage !== 1) || (checkIndex === this.pageSize - 1 && this.currentPage !== totalPages)) {
						this.getIzinPresensi();
						return;
					}

					this.izinPresensi = tempExists;

					return;
				}

				const tempOld = [...this.izinPresensi];
				const tempNew = [...this.izinPresensi];

				tempOld.push(oldData);
				tempNew.push({
					...newData,
					tanggal_formatted: new Date(newData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
					created_at: new Date(newData.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					updated_at: new Date(newData.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					previewBuktiIzin: newData.bukti_izin ? `${process.env.VUE_APP_API}/izin/bukti-izin/${newData.izin_presensi_id}?ts=${Date.now()}` : null,
				});

				tempOld.sort((a, b) => {
					const tglA = new Date(a.tanggal);
					const tglB = new Date(b.tanggal);

					return tglA - tglB || a.nama.localeCompare(b.nama);
				});
				tempNew.sort((a, b) => {
					const tglA = new Date(a.tanggal);
					const tglB = new Date(b.tanggal);

					return tglA - tglB || a.nama.localeCompare(b.nama);
				});

				const oldDataIndex = tempOld.findIndex((t) => t.izin_presensi_id === oldData.izin_presensi_id);
				const newDataIndex = tempNew.findIndex((t) => t.izin_presensi_id === newData.izin_presensi_id);

				if (oldDataIndex === 0) {
					if (newDataIndex === 0) return;

					if (newDataIndex < this.pageSize) {
						tempNew.shift();

						this.izinPresensi = tempNew;

						return;
					}
				}

				if (oldDataIndex === this.pageSize) {
					if (newDataIndex === this.pageSize) return;

					if (newDataIndex > 0) {
						tempNew.pop();

						this.izinPresensi = tempNew;

						return;
					}
				}

				this.getIzinPresensi();
				return;
			}
		},
		deletedIzin(data) {
			const oldData = data.old_izin_presensi;

			if (oldData.type !== "non_gtk") return;

			const totalPages = Math.ceil(this.totalData / this.pageSize);

			const userFiltered = this.izinFilter.user_presensi_id !== null && this.izinFilter.user_presensi_id !== "";
			const dateRangeFiltered = Array.isArray(this.izinFilter.tanggal);
			const izinMasukFiltered = this.izinFilter.izin_masuk !== null && this.izinFilter.izin_masuk !== "";
			const izinPulangFiltered = this.izinFilter.izin_pulang !== null && this.izinFilter.izin_pulang !== "";
			const izinPenuhFiltered = this.izinFilter.izin_penuh !== null && this.izinFilter.izin_penuh !== "";

			const oldUserMatched = !userFiltered || oldData.user_presensi_id === this.izinFilter.user_presensi_id;
			const oldDateMatched = !dateRangeFiltered || this.isDateInRange(this.izinFilter.tanggal, oldData.tanggal);
			const oldIzinMasukMatched = !izinMasukFiltered || oldData.izin_masuk === this.izinFilter.izin_masuk;
			const oldIzinPulangMatched = !izinPulangFiltered || oldData.izin_pulang === this.izinFilter.izin_pulang;
			const oldIzinPenuhMatched = !izinPenuhFiltered || oldData.izin_penuh === this.izinFilter.izin_penuh;

			if (userFiltered && !oldUserMatched) {
				return;
			}

			if (dateRangeFiltered && !oldDateMatched) {
				return;
			}

			if (izinMasukFiltered && !oldIzinMasukMatched) {
				return;
			}

			if (izinPulangFiltered && !oldIzinPulangMatched) {
				return;
			}

			if (izinPenuhFiltered && !oldIzinPenuhMatched) {
				return;
			}

			const oldMatched = oldUserMatched && oldDateMatched && oldIzinMasukMatched && oldIzinPulangMatched && oldIzinPenuhMatched;

			if (!oldMatched) {
				return;
			}

			const existIndex = this.izinPresensi.findIndex((ip) => ip.izin_presensi_id === oldData.izin_presensi_id);

			if (existIndex !== -1) {
				if (this.rowEditing && this.rowEditing.izin_presensi_id === oldData.izin_presensi_id) this.cancelEdit();

				if (this.currentPage === totalPages) {
					this.izinPresensi.splice(existIndex, 1);
					this.totalData--;
					return;
				}

				this.getIzinPresensi();
				return;
			}

			const temp = [...this.izinPresensi];

			temp.push(oldData);
			temp.sort((a, b) => {
				const tglA = new Date(a.tanggal);
				const tglB = new Date(b.tanggal);

				return tglA - tglB || a.nama.localeCompare(b.nama);
			});

			const oldDataIndex = temp.findIndex((t) => t.izin_presensi_id === oldData.izin_presensi_id);
			if (oldDataIndex === this.pageSize) {
				this.totalData--;
				return;
			}

			if (oldDataIndex === 0 && this.currentPage === totalPages) {
				this.izinPresensi.shift();
				this.totalData--;
				return;
			}

			this.getIzinPresensi();
		},
		insertedUser(data) {
			if (data.type !== "non_gtk") return;

			const newData = {
				user_presensi_id: data.user_presensi_id,
				non_gtk_id: data.non_gtk_id,
				nama: data.nama,
			};

			const temp = [...this.listUser];

			temp.push(newData);
			temp.sort((a, b) => {
				return a.nama.localeCompare(b.nama);
			});

			this.listUser = temp;
		},
		updatedUser(data) {
			if (data.type !== "non_gtk") return;

			if (this.izinFilter.user_presensi_id === data.old_user_presensi_id) {
				this.izinFilter.user_presensi_id = data.user_presensi_id;
			}

			this.listUser.every((u) => {
				if (u.user_presensi_id === data.old_user_presensi_id) {
					u.user_presensi_id = data.user_presensi_id;

					return false;
				}
				return true;
			});
			this.izinPresensi.forEach((i) => {
				if (i.user_presensi_id === data.old_user_presensi_id) {
					i.user_presensi_id = data.user_presensi_id;
				}
			});
		},
		deletedUser(data) {
			if (data.type !== "non_gtk") return;

			if (this.izinFilter.user_presensi_id === data.old_user_presensi_id) {
				this.izinFilter.user_presensi_id = null;
			}

			const oldUserIndex = this.listUser.findIndex((u) => u.user_presensi_id === data.old_user_presensi_id);
			if (oldUserIndex !== -1) this.listUser.splice(oldUserIndex, 1);
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, [
					"Anda yakin ingin menghapus izin presensi ",
					h("strong", row.nama),
					" tanggal ",
					h("strong", new Date(row.tanggal).toLocaleDateString("id-ID", { dateStyle: "long" })),
					"?",
				]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteIzinPresensi(row))
				.catch(() => {});
		},
		editData(row) {
			this.rowEditing = row;
			this.dialogEditVisible = true;
		},
		cancelEdit() {
			this.dialogEditVisible = false;
			this.rowEditing = null;
			this.$refs.formEdit.resetFields();
			this.previewBuktiIzinEdit = null;
		},
		async getIzinPresensi() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.get("/izin/index/non-gtk", {
					params: {
						user_presensi_id: this.izinFilter.user_presensi_id || undefined,
						tanggal_awal: Array.isArray(this.izinFilter.tanggal) ? this.izinFilter.tanggal[0] : undefined,
						tanggal_akhir: Array.isArray(this.izinFilter.tanggal) ? this.izinFilter.tanggal[1] : undefined,
						izin_masuk: this.izinFilter.izin_masuk,
						izin_pulang: this.izinFilter.izin_pulang,
						izin_penuh: this.izinFilter.izin_penuh,
						page: this.currentPage,
						limit: this.pageSize,
					},
				});

				const izin = data.data.izin_presensi.map((i) => ({
					...i,
					tanggal_formatted: new Date(i.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
					created_at: new Date(i.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					updated_at: i.updated_at ? new Date(i.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }) : null,
					previewBuktiIzin: i.bukti_izin ? `${process.env.VUE_APP_API}/izin/bukti-izin/${i.izin_presensi_id}?ts=${Date.now()}` : null,
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.izinPresensi = izin;
				this.totalData = data.data.jumlah_data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		async getListUserPresensi() {
			try {
				const { data } = await this.$defaultApi.get("/user/list/non-gtk");

				this.listUser = data.data.list_user_presensi;
			} catch (error) {
				console.error(error);
			}
		},
		async insertIzinPresensi() {
			this.inserting = true;
			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const formData = new FormData();

				for (const [key, value] of Object.entries(this.formCreate)) {
					formData.append(key, value);
				}

				const { data } = await this.$defaultApi.post("/izin", formData);

				this.dialogCreateVisible = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateIzinPresensi() {
			this.updating = true;
			try {
				if (!this.formEditChanged) {
					throw Error("Anda belum melakukan perubahan");
				}

				const valid = await this.$refs.formEdit.validate((res) => {
					return res;
				});

				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const formData = new FormData();

				const {
					user_presensi_id,
					tanggal,
					izin_masuk,
					izin_pulang,
					izin_penuh,
					keterangan,
					bukti_izin,
					del_izin_masuk,
					del_izin_pulang,
					del_izin_penuh,
					del_keterangan,
					del_bukti_izin,
				} = this.formEdit;

				if (user_presensi_id) formData.append("user_presensi_id", user_presensi_id);
				if (tanggal) formData.append("tanggal", tanggal);

				if (izin_masuk) {
					formData.append("izin_masuk", izin_masuk);
				} else if (del_izin_masuk) {
					formData.append("izin_masuk", null);
				}

				if (izin_pulang) {
					formData.append("izin_pulang", izin_pulang);
				} else if (del_izin_pulang) {
					formData.append("izin_pulang", null);
				}

				if (izin_penuh) {
					formData.append("izin_penuh", izin_penuh);
				} else if (del_izin_penuh) {
					formData.append("izin_penuh", null);
				}

				if (keterangan) {
					formData.append("keterangan", keterangan);
				} else if (del_keterangan) {
					formData.append("keterangan", null);
				}

				if (bukti_izin) {
					formData.append("bukti_izin", bukti_izin);
				} else if (del_bukti_izin) {
					formData.append("hapus_bukti", del_bukti_izin);
				}

				const { data } = await this.$defaultApi.patch(`/izin/${this.rowEditing.izin_presensi_id}`, formData);

				this.dialogEditVisible = false;
				this.rowEditing = null;
				this.$refs.formEdit.resetFields();
				this.previewBuktiIzinEdit = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.updating = false;
				}, 500);
			}
		},
		async deleteIzinPresensi(row) {
			this.deleting = true;
			try {
				const { data } = await this.$defaultApi.delete(`/izin/${row.izin_presensi_id}`);

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = false;
				}, 500);
			}
		},
		async syncRekapPresensi() {
			this.syncing = true;
			try {
				const { data } = await this.$defaultApi.post("/izin/sync-rekap");

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.syncing = false;
			}
		},
	},
};
</script>

<style scoped>
.deleted-value :deep(.el-select__placeholder.is-transparent) {
	text-decoration: line-through;
	font-style: italic;
}
.deleted-value :deep(.el-textarea__inner)::-webkit-input-placeholder {
	text-decoration: line-through;
	font-style: italic;
}
.deleted-value :deep(.el-textarea__inner)::-moz-placeholder {
	text-decoration: line-through;
	font-style: italic;
}
.deleted-value :deep(.el-textarea__inner):-ms-input-placeholder {
	text-decoration: line-through;
	font-style: italic;
}
.deleted-value :deep(.el-textarea__inner)::placeholder {
	text-decoration: line-through;
	font-style: italic;
}
</style>
